<template>
  <div>
    <v-flex>
      <v-switch label="Utiliser le thème sombre"
                :input-value="darkTheme"
                @change="changementTheme"></v-switch>
    </v-flex>
    <v-flex>
      <v-btn block depressed :loading="loadingSignOut" :disabled="loadingSignOut" large @click="logout();loadingSignOut=true;" color="error">Déconnexion</v-btn>
    </v-flex>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { THEME_MUTATION } from '@/store'
export default {
  data() {
    return {
      loadingSignOut: false,
    }
  },
  computed: {
    ...mapState(['darkTheme'])
  },
  methods: {
    ...mapMutations({
      changementTheme: THEME_MUTATION
    }),
    ...mapActions({
      logout: 'signOutOidc'
    })
  }
}
</script>